import type { RouteRecordRaw } from "vue-router";
export const WorkflowsRoutes: RouteRecordRaw[] = [
    {
        path: '',
        name: 'workflowsList',
        component: () => import('./components/ListWorkflow.vue')
    },
    {
        path: ':id',
        name: 'workflowsView',
        component: () => import('./components/ViewWorkflow/Index.vue'),
        children: [
            {
                path: '',
                name: 'workflowKanban',
                component: () => import('./components/ViewWorkflow/KanbanWorkflow/Index.vue')
            },
            {
                path: 'list',
                name: 'workflowTable',
                component: () => import('./components/ViewWorkflow/TableWorkflow/Index.vue')
            },
            {
                path: 'card/:id_fluxo_registro',
                name: 'workflowCard',
                component: () => import('./components/ViewWorkflow/KanbanWorkflow/Index.vue')
            },
            {
                path: 'diagram',
                name: 'workflowDiagram',
                component: () => import('./components/ViewWorkflow/DiagramWorkflow/Index.vue')
            },
            {
                path: 'reports',
                name: 'workflowReport',
                component: () => import('./components/ViewWorkflow/ReportWorkflow/Index.vue'),
                children: [
                    {
                        path: '',
                        name: 'workflowReportList',
                        component: () => import('./components/ViewWorkflow/ReportWorkflow/ListReport.vue')
                    },
                    {
                        path: ':id_report',
                        name: 'workflowReportView',
                        component: () => import('./components/ViewWorkflow/ReportWorkflow/ViewReport/Index.vue'),
                    }
                ]
            },
            {
                path: 'external-form',
                name: 'workflowExternalForm',
                component: () => import('./components/ViewWorkflow/ExternalFormWorkflow/Index.vue')
            },
            {
                path: 'mail',
                name: 'workflowMail',
                component: () => import('./components/ViewWorkflow/MailWorkflow/Index.vue')
            }
        ]
    }
]